'use client';

import { useQuery } from '@tanstack/react-query';
import { createBffClient } from '@/lib/bff/create-storefront-client';
import { usePricingContext } from '@/lib/hooks/use-pricing-context';
import { env } from '@/lib/utils/env';

async function fetchPackName(
  packId: string,
  pricingQuery: { currency: string; country: string },
): Promise<string | null> {
  if (!env.STOREFRONT_BFF_URL) return null;

  try {
    const client = createBffClient();
    const res = await client.getPackById(packId, pricingQuery);
    return res.data.name || null;
  } catch {
    return null;
  }
}

export function usePackName(packId: string | undefined | null) {
  const { currency, country, query } = usePricingContext();

  return useQuery<string | null>({
    queryKey: ['pack-name', packId, currency, country],
    queryFn: async () => {
      if (!packId) return null;
      return fetchPackName(packId, query);
    },
    enabled: !!packId && !!env.STOREFRONT_BFF_URL,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
}
